/**
 * Cards grid (002) Block JavaScript
 *
 * @package TekCreative
 * @since 2.0.0
 */

import SplideCarousel from '../../../../javascript/components/splide.js';

(function() {
    'use strict';

    const FourColCards002 = {
        selector: '.four-col-cards-002',

        init() {
            const blocks = document.querySelectorAll(this.selector);
            if (!blocks.length) return;

            blocks.forEach(block => this.initBlock(block));
        },

        initBlock(block) {
            this.initCarousel(block);
        },

        initCarousel(block) {
            // Only initialise the mobile/tablet carousel (.splide-carousel)
            // The desktop grid (.four-col-cards-002__grid) is plain HTML — no JS needed.
            const sliders = block.querySelectorAll('.splide-carousel');
            sliders.forEach(slider => {
                SplideCarousel.init(slider);
            });
        },
    };

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => FourColCards002.init());
    } else {
        FourColCards002.init();
    }

    // Re-initialize for Gutenberg editor preview
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=four-col-cards-002', () => {
            setTimeout(() => FourColCards002.init(), 100);
        });
    }

})();
